export default "<app-header *ngIf=\"currentUser\"></app-header>\n<router-outlet></router-outlet>\n<app-footer *ngIf=\"currentUser\"></app-footer>"